import TextEditorButton from 'flarum/common/components/TextEditorButton';
import GifIcon from './GifIcon';

/**
 * The composer toolbar button that opens the picker.
 *
 * Exists only to put an inline SVG where core would put a Font Awesome glyph.
 * Core's `icon` attr runs through a helper that emits `<i class="fas ...">`,
 * and Font Awesome 5 free — the set Flarum ships — has no GIF glyph.
 *
 * Passing the SVG as a child does not work either: children are wrapped in
 * `.Button-label`, and the `Button--icon` class every toolbar button uses
 * hides that element. Overriding `getButtonContent` puts the mark in the icon
 * slot instead, which is the element `Button--icon` actually styles and shows.
 */
export default class GifPickerButton extends TextEditorButton {
  getButtonContent() {
    // Matches what core's icon helper produces for a Font Awesome button:
    // a single element carrying `Button-icon`, and no label.
    return [<GifIcon className="Button-icon" />];
  }
}
